// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__pLg4Q","ttl":"styles_ttl__tXvQL","txt":"styles_txt__RPDi3","btnSec1":"styles_btnSec1__DwFuH","btnSec2":"styles_btnSec2__2ETcM","img":"styles_img__pPjxm"};